/* EcoYoung — popup powitalny newslettera.
   Trigger: 8s LUB 15% scrolla (min. 400px, nie wczesniej niz 4s po wejsciu) LUB exit-intent (desktop).
   Frequency cap: subskrybent = nigdy; dismiss = 30 dni; max 1x/sesja.
   Zapis: Klaviyo client/subscriptions (202 = sukces). Tracking: dataLayer.
   Markup + config: snippets/ey-popup-newsletter.liquid. Style: assets/ey-popup.css. */
(function () {
  'use strict';

  var root = document.getElementById('ey-pop-root');
  if (!root) return;

  var overlay    = root.querySelector('.ey-pop-overlay');
  var pop        = root.querySelector('.ey-pop');
  var form       = root.querySelector('.ey-pop__form');
  var input      = root.querySelector('.ey-pop__input');
  var cta        = root.querySelector('.ey-pop__cta');
  var ctaLabel   = root.querySelector('.ey-pop__cta-label');
  var errorEl    = root.querySelector('.ey-pop__error');
  var closeBtn   = root.querySelector('.ey-pop__close');
  var declineBtn = root.querySelector('.ey-pop__decline');

  if (!overlay || !pop || !form || !input || !cta) return;

  var COMPANY  = root.getAttribute('data-ey-company');
  var LIST_ID  = root.getAttribute('data-ey-list');
  var REVISION = root.getAttribute('data-ey-revision');
  var SOURCE   = root.getAttribute('data-ey-source') || 'Popup EcoYoung';
  var CTA_DEFAULT = ctaLabel ? ctaLabel.textContent : '';

  var LS_SUB = 'ey_popup_subscribed';
  var LS_DIS = 'ey_popup_dismissed_at';
  var SS_SESSION = 'ey_popup_shown_session';
  var DISMISS_MS = 30 * 24 * 60 * 60 * 1000;

  var params    = new URLSearchParams(location.search);
  var forceShow = params.get('ey_popup') === '1';
  var noPopup   = params.get('ey_nopopup') === '1';

  var lastFocused = null;
  var timer = null, scrollHandler = null, exitHandler = null;

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  function track(event) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: event, source: 'popup' });
    } catch (e) {}
  }

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function eligible() {
    if (noPopup) return false;
    if (forceShow) return true;
    var p = location.pathname;
    if (p === '/cart' || p.indexOf('/cart') === 0 || p.indexOf('/checkout') === 0) return false;
    if (lsGet(LS_SUB) === '1') return false;
    if (ssGet(SS_SESSION) === '1') return false;
    var dis = parseInt(lsGet(LS_DIS), 10);
    if (dis && (Date.now() - dis) < DISMISS_MS) return false;
    return true;
  }

  function focusable() {
    return Array.prototype.slice.call(pop.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) { dismiss(); return; }
    if (e.key === 'Tab' || e.keyCode === 9) {
      var f = focusable();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function removeTriggers() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (scrollHandler) { window.removeEventListener('scroll', scrollHandler); scrollHandler = null; }
    if (exitHandler) { document.removeEventListener('mouseout', exitHandler); exitHandler = null; }
  }

  function open() {
    if (overlay.classList.contains('is-open')) return;
    removeTriggers();
    ssSet(SS_SESSION, '1');
    lastFocused = document.activeElement;
    document.documentElement.classList.add('ey-pop-locked');
    document.body.classList.add('ey-pop-locked');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', onKeydown, true);
    track('ey_popup_view');
    // Fokus na kontener dialogu (nie na input) — input ma autocomplete="email",
    // fokus otwierałby dymek autouzupełniania zasłaniający popup (+ klawiaturę na mobile).
    window.setTimeout(function () { try { pop.focus(); } catch (e) {} }, 60);
  }

  function hide() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ey-pop-locked');
    document.body.classList.remove('ey-pop-locked');
    document.removeEventListener('keydown', onKeydown, true);
    if (lastFocused && lastFocused.focus) { try { lastFocused.focus(); } catch (e) {} }
  }

  function dismiss() {
    if (!overlay.classList.contains('is-open')) return;
    if (!pop.classList.contains('is-success')) {
      lsSet(LS_DIS, String(Date.now()));
      track('ey_popup_dismiss');
    }
    hide();
  }

  function showError(msg) {
    pop.classList.add('is-invalid');
    if (errorEl) errorEl.textContent = msg;
  }
  function clearError() { pop.classList.remove('is-invalid'); }

  function setLoading(on) {
    if (on) {
      pop.classList.add('is-loading');
      cta.disabled = true;
      if (ctaLabel) ctaLabel.textContent = 'Zapisuję…';
    } else {
      pop.classList.remove('is-loading');
      cta.disabled = false;
      if (ctaLabel) ctaLabel.textContent = CTA_DEFAULT;
    }
  }

  // Zapis przez client/subscriptions NIE ustawia ciasteczka __kla_id, wiec bez
  // tego wywolania subskrybent zostaje anonimowy dla trackingu onsite. Dopiero
  // identify() wiaze sesje z profilem, dzieki czemu Viewed Product i Added to
  // Cart trafiaja na wlasciwy profil i moga odpalac flow porzuconego koszyka.
  // Wariant z push() jest awaryjny: zanim klaviyo.js sie zaladuje, window.klaviyo
  // jest tablica-zaslepka i nie ma jeszcze metody identify.
  function identifyInKlaviyo(email) {
    try {
      var k = window.klaviyo;
      if (!k) return;
      if (typeof k.identify === 'function') { k.identify({ email: email }); }
      else if (typeof k.push === 'function') { k.push(['identify', { email: email }]); }
    } catch (e) {}
  }

  function success(email) {
    setLoading(false);
    pop.classList.add('is-success');
    lsSet(LS_SUB, '1');
    identifyInKlaviyo(email);
    track('ey_popup_success');
    window.setTimeout(function () {
      if (pop.classList.contains('is-success')) hide();
    }, 4000);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (input.value || '').trim();
    if (!validEmail(email)) { showError('Sprawdź adres e-mail.'); input.focus(); return; }
    clearError();
    setLoading(true);
    track('ey_popup_submit');

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: SOURCE,
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: LIST_ID } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (res.status === 202 || (res.status >= 200 && res.status < 300)) { success(email); }
        else { throw new Error('HTTP ' + res.status); }
      })
      .catch(function () {
        setLoading(false);
        showError('Coś nie zadziałało. Spróbuj jeszcze raz albo napisz: meble@ecoyoung.pl');
      });
  });

  input.addEventListener('blur', function () {
    if (input.value && !validEmail(input.value.trim())) showError('Sprawdź adres e-mail.');
  });
  input.addEventListener('input', function () {
    if (pop.classList.contains('is-invalid')) clearError();
  });

  closeBtn.addEventListener('click', dismiss);
  declineBtn.addEventListener('click', dismiss);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) dismiss(); });

  var TRIG_TIME_MS  = 8000;   // 8 s na stronie
  var TRIG_SCROLL   = 0.15;   // 15 % wysokosci dokumentu
  var TRIG_MIN_PX   = 400;    // minimalny bezwzgledny dystans przewijania
  var TRIG_DWELL_MS = 4000;   // zaden trigger nie odpali wczesniej niz 4 s
  var TRIG_MIN_DOC  = 600;    // krotkie strony: sam timer, bez scrolla
  var armedAt = 0;

  function initTriggers() {
    armedAt = Date.now();
    timer = window.setTimeout(open, TRIG_TIME_MS);

    // Fix mobile: przywrocona pozycja scrolla przy powrocie oraz chowanie
    // paska adresu generowaly zdarzenie scroll natychmiast po wejsciu, przez
    // co popup wyskakiwal od razu. Trzy bezpieczniki ponizej to blokuja.
    scrollHandler = function () {
      if (Date.now() - armedAt < TRIG_DWELL_MS) return;
      var st = window.pageYOffset || document.documentElement.scrollTop || 0;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h < TRIG_MIN_DOC) return;
      if (st < TRIG_MIN_PX) return;
      if ((st / h) >= TRIG_SCROLL) open();
    };
    window.addEventListener('scroll', scrollHandler, { passive: true });

    if (window.matchMedia && window.matchMedia('(min-width: 601px) and (pointer: fine)').matches) {
      exitHandler = function (e) {
        if (e.clientY <= 0 && !e.relatedTarget) open();
      };
      document.addEventListener('mouseout', exitHandler);
    }
  }

  function start() {
    if (forceShow) { open(); return; }
    if (!eligible()) return;
    initTriggers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();